import Swiper from "swiper";
import { Navigation, A11y } from "swiper/modules";

const imageSlider = (slider, index) => {
	const prevButton = slider.querySelector(".swiper-button-prev");
	const nextButton = slider.querySelector(".swiper-button-next");
	const currentSlider = slider.querySelector(".swiper-container");

	// define the new classes with the index
	const prevButtonClass = `swiper-button-prev-${index}`;
	const nextButtonClass = `swiper-button-next-${index}`;
	const sliderClass = `js--image-slider-${index}`;

	// remove existing classes and replace them with the new ones
	if (prevButton) {
		prevButton.className = prevButtonClass;
	}

	if (nextButton) {
		nextButton.className = nextButtonClass;
	}
	if (currentSlider) {
		currentSlider.className = sliderClass;
	}

	new Swiper(`.js--image-slider-${index}`, {
		modules: [Navigation, A11y],
		a11y: {
			prevSlideMessage: "Previous slide",
			nextSlideMessage: "Next slide",
		},
		direction: "horizontal",
		loop: false,
		freeMode: false,
		observer: true,
		observeParents: true,
		centeredSlides: false,
		watchOverflow: true,
		navigation: {
			prevEl: `.swiper-button-prev-${index}`,
			nextEl: `.swiper-button-next-${index}`,
		},
		spaceBetween: 20,
		slidesPerView: 1,
	});
};

export default imageSlider;
